const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * A campaign id arriving in the query string — the sidebar's campaign link, a
 * shared list URL, the donation list's *Bağış Ekle*. The query string is a
 * contract input one hop later and a reader can edit it, so anything that is
 * not a whole uuid is unset rather than sent —
 * .claude/rules/list-screen-pattern.md, *What may reach the URL*.
 */
export function campaignUrlId(value: string | null | undefined): string | undefined {
  return value && UUID.test(value) ? value : undefined;
}

/**
 * The value a campaign picker may show. MUI reports an out-of-range value for
 * anything its options do not hold, and a campaign outside the caller's
 * collection scope, an archived one, or a list still in flight is exactly that
 * — so the control stays empty until the id it was given is one of its own.
 * The filter itself is still sent: the server decides what a caller may see,
 * and the applied-filter chip is how the operator removes it.
 */
export function offeredCampaignId(
  value: string | undefined,
  options: readonly { id: string }[],
): string {
  return value && options.some((option) => option.id === value) ? value : '';
}
